import { useReducer } from 'react';
import constate from 'constate';
import createReducer from 'helpers/reducers-helper';
import assign from 'lodash/assign';
import { useAppContext, UPDATE_USER_INFO } from 'use-app';
import repo from 'service/repository';
import { errorHandler } from 'helpers/error-handler';

export const INITIALIZE = 'initialize';
export const CHANGE_SETTING_DIALOG_SHOW = 'change_setting_dialog_show';
export const SHOW_LOADING = 'show_loading';
export const HIDE_LOADING = 'hide_loading';

const useMochiPayFlow = () => {
  const { dispatch: appDispatch, showFailMessage } = useAppContext();
  const initState = {
    theme: 'default',
    cards: [],
    settingDialogShow: false,
    loading: true,
  };

  const changeSettingDialogShow = (state, payload) => assign({}, state, { settingDialogShow: payload });
  const showLoading = state => assign({}, state, { loading: true });
  const hideLoading = state => assign({}, state, { loading: false });
  const init = (state, payload) => assign({}, state, payload);

  const removeNpc = () => {
    repo
      .deleteCreditCard()
      .then(repo.fetchUserInfo)
      .then(data => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: data,
        });
        initialize();
      })
      .catch(error => {
        showFailMessage(errorHandler(error));
      });
  };

  const bindNpc = ({ type, redeemDiscountState }) => {
    dispatch({ type: SHOW_LOADING });

    repo
      .bindNpcPay({ cardType: type, enableRedeem: redeemDiscountState })
      .then(repo.fetchUserInfo)
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
      })
      .catch(error => {
        showFailMessage(errorHandler(error));
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADING });
      });
  };

  const initialize = async () => {
    let cards = await repo.getNpcCards();

    dispatch({
      type: INITIALIZE,
      payload: {
        cards,
        loading: false,
      },
    });
  };

  const reducer = createReducer(
    {
      [INITIALIZE]: init,
      [CHANGE_SETTING_DIALOG_SHOW]: changeSettingDialogShow,
      [SHOW_LOADING]: showLoading,
      [HIDE_LOADING]: hideLoading,
    },
    initState,
    true
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return { state, dispatch, initialize, removeNpc, bindNpc };
};

const [MochipayFlowProvider, useMochiPayFlowContext] = constate(useMochiPayFlow);
export { MochipayFlowProvider, useMochiPayFlowContext };
